import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';  // Importamos Link de react-router-dom

const RutasExels = () => {
  const [isTokenValid, setIsTokenValid] = useState(true); // Estado para almacenar si el token es válido
    const navigate = useNavigate(); // Usamos useNavigate para redirección en v6
  
    // Verificar token al cargar el componente
    useEffect(() => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        // Si no hay token, redirigir o actualizar el estado
        setIsTokenValid(false);
        navigate('/login'); // Usamos navigate en lugar de history.push
      } else {
      
        setIsTokenValid(true);
      }
    }, [navigate]); // Esto se ejecuta cuando el componente se monta
  const rutas = [
    { path: '/ExelConcentimiento', label: 'Excel Concentimiento' },
    { path: '/Exel_Inclusion', label: 'Excel Inclusión' },
    { path: '/Exel_Exclusion', label: 'Excel Exclusión' },
    { path: '/Exel_HClinica', label: 'c Historia Clínica' },
    { path: '/Exel_Signos', label: 'Excel Signos' },
    { path: '/Exel_Concomitantes', label: 'Excel Concomitantes' },
    { path: '/Exel_Adversos', label: 'Excel Adversos' },
  ];

  return (
    <div className="container">
      <h2>Control de Rutas</h2>
      <div className="routes-container">
        {rutas.map(({ path, label }) => (
          <div key={path} className="route-item">
            <Link to={path}>
              <button className="boton-nuevo">{label}</button> {/* Añadí la clase boton-nuevo */}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RutasExels;
